import Img24 from './post-2.webp'
import Img23 from './post-3.webp'
import Img22 from './post-4.webp'
import Img21 from './post-5.webp'
import Img20 from './post-6.webp'
import Img19 from './post-7.webp'
import Img18 from './post-8.webp'
import Img17 from './post-9.webp'
import Img16 from './post-10.webp'
import Img15 from './post-11.webp'
import Img14 from './post-12.webp'
import Img13 from './post-13.webp'
import Img12 from './post-14.webp'
import Img11 from './post-15.webp'
import Img10 from './post-16.webp'
import Img9 from './post-17.webp'
import Img8 from './post-18.webp'
import Img7 from './post-19.webp'
import Img6 from './post-20.webp'
import Img5 from './post-21.webp'
import Img4 from './post-22.webp'
import Img3 from './post-23.webp'
import Img2 from './post-24.webp'
import Img1 from './post-25.webp'
import Img26 from './post-26.webp'
import Img28 from './post-28.webp'
import Img29 from './post-29.webp'
import Img30 from './post-30.webp'
import Img32 from './post-32.webp'
import Img33 from './post-33.webp'
import Img34 from './post-34.webp'
import Img35 from './post-35.webp'
import Img39 from './post-39.webp'
import Img42 from './post-42.webp'
import Img44 from './post-44.webp'
import Img45 from './post-45.webp'
import Img46 from './post-46.webp'
import Img47 from './post-47.webp'
import Img48 from './post-48.webp'
import Img49 from './post-49.webp'
import Img50 from './post-50.webp'
import Img51 from './post-51.webp'
import Img52 from './post-52.webp'
import Img53 from './post-53.webp'
import Img54 from './post-54.webp'
import Img55 from './post-55.webp'
import Img56 from './post-56.webp'
import Img57 from './post-57.webp'
import Img58 from './post-58.webp'
import Img59 from './post-59.webp'
import Img60 from './post-60.webp'
import Img61 from './post-61.webp'
import Img62 from './post-62.webp'
import Img63 from './post-63.webp'
import Img64 from './post-64.webp'
import Img65 from './post-65.webp'
import Img66 from './post-66.webp'
import Img67 from './post-67.webp'
import Img68 from './post-68.webp'
import Img69 from './post-69.webp'
import Img70 from './post-70.webp'
import Img71 from './post-71.webp'
import Img72 from './post-72.webp'
import Img73 from './post-73.webp'
import Img74 from './post-74.webp'
import Img75 from './post-75.webp'
import Img76 from './post-76.webp'
import Img77 from './post-77.webp'
import Img78 from './post-78.webp'
import Img79 from './post-79.webp'
import Img80 from './post-80.webp'
import Img81 from './post-81.webp'
import Img82 from './post-82.webp'
import Img83 from './post-83.webp'
import Img84 from './post-84.webp'
import Img85 from './post-85.webp'
import Img86 from './post-86.webp'
import Img87 from './post-87.webp'
import Img88 from './post-88.webp'
import Img89 from './post-89.webp'
import Img90 from './post-90.webp'
import Img91 from './post-91.webp'
import Img92 from './post-92.webp'
import Img93 from './post-93.webp'

const Blog = {
  IMG_24: Img24,
  IMG_23: Img23,
  IMG_22: Img22,
  IMG_21: Img21,
  IMG_20: Img20,
  IMG_19: Img19,
  IMG_18: Img18,
  IMG_17: Img17,
  IMG_16: Img16,
  IMG_15: Img15,
  IMG_14: Img14,
  IMG_13: Img13,
  IMG_12: Img12,
  IMG_11: Img11,
  IMG_10: Img10,
  IMG_9: Img9,
  IMG_8: Img8,
  IMG_7: Img7,
  IMG_6: Img6,
  IMG_5: Img5,
  IMG_4: Img4,
  IMG_3: Img3,
  IMG_2: Img2,
  IMG_1: Img1,
  IMG_26: Img26,
  IMG_28: Img28,
  IMG_29: Img29,
  IMG_30: Img30,
  IMG_32: Img32,
  IMG_33: Img33,
  IMG_34: Img34,
  IMG_35: Img35,
  IMG_39: Img39,
  IMG_42: Img42,
  IMG_44: Img44,
  IMG_45: Img45,
  IMG_46: Img46,
  IMG_47: Img47,
  IMG_48: Img48,
  IMG_49: Img49,
  IMG_50: Img50,
  IMG_51: Img51,
  IMG_52: Img52,
  IMG_53: Img53,
  IMG_54: Img54,
  IMG_55: Img55,
  IMG_56: Img56,
  IMG_57: Img57,
  IMG_58: Img58,
  IMG_59: Img59,
  IMG_60: Img60,
  IMG_61: Img61,
  IMG_62: Img62,
  IMG_63: Img63,
  IMG_64: Img64,
  IMG_65: Img65,
  IMG_66: Img66,
  IMG_67: Img67,
  IMG_68: Img68,
  IMG_69: Img69,
  IMG_70: Img70,
  IMG_71: Img71,
  IMG_72: Img72,
  IMG_73: Img73,
  IMG_74: Img74,
  IMG_75: Img75,
  IMG_76: Img76,
  IMG_77: Img77,
  IMG_78: Img78,
  IMG_79: Img79,
  IMG_80: Img80,
  IMG_81: Img81,
  IMG_82: Img82,
  IMG_83: Img83,
  IMG_84: Img84,
  IMG_85: Img85,
  IMG_86: Img86,
  IMG_87: Img87,
  IMG_88: Img88,
  IMG_89: Img89,
  IMG_90: Img90,
  IMG_91: Img91,
  IMG_92: Img92,
  IMG_93: Img93,
}

export default Blog
